export const selectOptions = [
  { id: "completion", name: "По факту завершения" },
  { id: "delay", name: "С отсрочкой" },
];
